import styled from 'styled-components';

export const OptionalText = styled.span`
  display: block;
`;

export const SmsTermsLink = styled.a`
  color: inherit;
  text-decoration: underline;
`;
